/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1089
 */

var r = require(/* 634 */"./1253/634").match(/AppleWebKit\/(\d+)\./)
module.exports = !!r && +r[1]
